import React from 'react'
import { Field, reduxForm } from 'redux-form'
import LgyInputField from 'app/components/util/lgy-input-field/LgyInputField'
import { userSearchFormValidator } from '../validators/userSearchFormValidator'
import LgyFormSubmit from 'app/components/util/lgy-form-submit/LgyFormSubmit'
import { username, name, minLength, numeric, ssn } from 'app/utils/validations'

const partialSearchText = 'Partial search allowed'
const exactSearchText = 'Values must match exactly'
const minLength4 = minLength(4)

const UserSearchForm = ({ pristine, submitting, submitFailed, submitSucceeded, reset, handleSubmit, error }) =>
  <form onSubmit={handleSubmit}>
    <div className='usa-width-one-whole top-row'>
      <div className='usa-width-one-third'>
        <Field
          name='username'
          type='text'
          label='Username'
          aria-label='For accounts originally registered in VIP, use their VIP portal name. For accounts registered through AccessVA, use their SecID.'
          tooltip='For accounts originally registered in VIP, use their VIP portal name. For accounts registered through AccessVA, use their SecID.'
          component={LgyInputField}
          placeholder={partialSearchText}
          validate={username}
          autoFocus
        />
      </div>
      <div className='usa-width-one-third'>
        <Field
          name='firstName'
          type='text'
          label='First Name'
          component={LgyInputField}
          placeholder={partialSearchText}
          validate={name}
        />
      </div>
      <div className='usa-width-one-third'>
        <Field
          name='lastName'
          type='text'
          label='Last Name'
          component={LgyInputField}
          placeholder={partialSearchText}
          validate={name}
        />
      </div>
    </div>
    <div className='usa-width-one-whole'>
      <div className='usa-width-one-third'>
        <Field
          name='email'
          type='text'
          label='Email'
          component={LgyInputField}
          placeholder={partialSearchText}
          validate={minLength4}
        />
      </div>
      <div className='usa-width-one-third'>
        <Field
          name='ssn'
          type='text'
          label='SSN'
          validate={ssn}
          component={LgyInputField}
          placeholder={exactSearchText}
          maxLength='9'
        />
      </div>
      <div className='usa-width-one-third'>
        <Field
          name='ssnLastFour'
          type='text'
          label='SSN Last Four'
          validate={[numeric, minLength4]}
          component={LgyInputField}
          placeholder={exactSearchText}
          maxLength='4'
        />
      </div>
    </div>
    <div className='usa-width-one-whole'>
      <div className='usa-width-one-third'>
        <Field
          name='vaEauthSecId'
          type='text'
          label='VA Eauth Sec ID'
          validate={[numeric]}
          component={LgyInputField}
          placeholder={exactSearchText}
        />
      </div>
    </div>
    <div className='usa-width-one-whole'>
      <LgyFormSubmit pristine={pristine} submitting={submitting} submitFailed={submitFailed} submitSucceeded={submitSucceeded} reset={reset} error={error} />
    </div>
  </form >

const userSearchReduxFormProps = {
  form: 'userSearchForm',
  validate: userSearchFormValidator,
  initialValues: { exactEmail: true }
}

export default reduxForm(userSearchReduxFormProps)(UserSearchForm)
